import { useFeatureFlag } from 'utils/hooks/useFeatureFlag';
import { Link } from 'react-router-dom';
import { FC, PropsWithChildren } from 'react';
import { Button, ButtonProps } from 'ui/button';
import { isDefined } from 'utils/tsHelpers';
import { MODERNIZED_SEGMENTATION_PAGE, SEGMENTATION_ENDPOINT } from '../constants';
import { SegmentationRedirect } from './types';

export type SegmentationLinkButtonProps = Partial<SegmentationRedirect> & ButtonProps;

export const DATA_TESTS = {
  linkButton: 'segmentation-link-button',
  withoutLinkButton: 'segmentation-wo-link-button',
};

/**
 * Button used to redirect to segmentation.
 * If feature flagged, it will redirect to segmentation via react router links but if not,
 * it will trigger the provided onClick
 */

export const SegmentationLinkButton: FC<PropsWithChildren<SegmentationLinkButtonProps>> = ({
  searchQuery,
  children,
  onClick,
  target,
  search,
  automaticallyLoadResults = true,
  ...props
}) => {
  const isModernizedSegmentationPageEnabled = useFeatureFlag(MODERNIZED_SEGMENTATION_PAGE);
  return isModernizedSegmentationPageEnabled && isDefined(searchQuery) ? (
    <Link
      data-test={DATA_TESTS.linkButton}
      onClick={(event) => {
        if (props.isDisabled) {
          event.preventDefault();
          return;
        }
      }}
      target={target}
      to={{
        search,
        state: { searchQuery, automaticallyLoadResults },
        pathname: SEGMENTATION_ENDPOINT,
      }}
    >
      <Button {...props}>{children}</Button>
    </Link>
  ) : (
    <Button data-test={DATA_TESTS.withoutLinkButton} onClick={onClick} {...props}>
      {children}
    </Button>
  );
};
